import { OrderStatus } from '@blisspointmedia/bpm-types/dist/LinearBuying';

export const MONTH_DAY_TIME_DATE_FORMAT = 'MM/dd p';
export const MONTH_DAY_DATE_FORMAT = 'MM/dd';

export const S3_LINEAR_ORDERS = 'bpm-linear-orders';

export const OrderAction = {
  SEND: 'send',
  MARK_SENT: 'markSent',
  REGENERATE: 'regenerate',
  CANCEL: 'cancel'
} as const;
export type OrderActionType = (typeof OrderAction)[keyof typeof OrderAction];

export interface OrderRow {
  id: number;
  company: string;
  network: string;
  avail: string;
  start_week: string;
  end_week: string;
  type: number;
  status: OrderStatus;
  revision: number;
  pdf_status: string;
  notes: string | null;
  lastmodified: string;
  lastuser: string;
  is_traffic: boolean;
  /** A blanket traffic instruction — traffic, but with its own document and send path. */
  is_blanket: boolean;
  orderVersion: string;
  s3Path: string;
  campaign: string | null;
  isV1?: boolean;
  order_id?: number; // for V1 orders
}

export interface FormattedOrderRow extends OrderRow {
  formattedWeeks: string;
  formattedOrder: string;
  formattedOrderStatus: string;
  formattedOrderType: string;
}

export interface SelectedOrder {
  id: number;
  isTraffic: boolean;
  isBlanket: boolean;
}

export type SelectedOrdersMap = Record<string, SelectedOrder>;

export interface OrderNote {
  notes: string;
  isTraffic: boolean;
  isBlanket: boolean;
}

export type OrderNotesMap = Record<string, OrderNote>;

export interface FileInfo {
  s3Key: string;
  file: File | undefined;
}
